export const PASSWORD_MIN_LENGTH = 10;

/** 0–3, drives the three-segment meter. The server applies the same rule on save. */
export function passwordStrength(pw: string): number {
  if (pw.length < PASSWORD_MIN_LENGTH) return 0;
  let score = 1;
  const classes = [/[a-z]/, /[A-Z]/, /\d/, /[^A-Za-z0-9]/].filter((r) => r.test(pw)).length;
  if (classes >= 3 || pw.length >= 16) score++;
  if (classes >= 3 && pw.length >= 14) score++;
  return score;
}
